module.exports = __webpack_public_path__ + "img/dongtaichoupan.565669a3.png";